<template>
    <div>
        <div class="box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>企业资质</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="content">
                <el-image style="width: 100%;"
                    src="https://uplabimg.andupchain.com/usermenu/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7%E5%89%AF%E6%9C%AC.png"
                    fit="fill"></el-image>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        go() {
            this.$router.push('/certification')
        }
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 1200px;
    margin: auto;
    padding: 20px 0;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
